import FileIcon from "./FileIcon";
import { legacyTypeStyle } from "./templateTypeStyle";
import { Stack, Typography } from "@mui/material";

const FileDetail = ({ name, filename, type, typeStyle = legacyTypeStyle }) => {
  const enDashChar = "\u2013";

  return (
    <Stack
      display={"inline-flex"}
      direction={"row"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={1}
    >
      <FileIcon type={type} typeStyle={typeStyle} />
      <Stack>
        <Typography
          fontWeight={"600"}
          color={`${typeStyle(type).fg} !important`}
          marginTop={0}
        >
          {name}
        </Typography>
        <Typography variant={"subtitle2"} sx={{ marginTop: "-3px !important" }}>
          {filename ?? enDashChar}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default FileDetail;
